module.exports = __webpack_public_path__ + "img/wav.640e0b8c.png";